export const goToStudioRoute = (componentKey) => `/studio/${componentKey}`
